"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { useEffect, useState } from "react";
import { useCopyToClipboard } from "react-use";
import CopyIcon from "@/components/utils/icons/CopyIcon";
export default function ProfileActivityLogItemValueWithCopy(t0) {
  const $ = _c(20);
  const {
    title,
    value
  } = t0;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const [, copyToClipboard] = useCopyToClipboard();
  const [titleToShow, setTitleToShow] = useState(title);
  let t3;
  if ($[2] !== copyToClipboard || $[3] !== title || $[4] !== value) {
    t3 = () => {
      copyToClipboard(value);
      setTitleToShow("Copied!");
      setTimeout(() => {
        setTitleToShow(title);
      }, 1000);
    };
    $[2] = copyToClipboard;
    $[3] = title;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCopy = t3;
  const t4 = `${isTouchScreen ? "tw-block" : "tw-hidden group-hover:tw-block"} tw-mx-1 tw-bg-transparent tw-cursor-pointer tw-text-sm tw-font-semibold tw-text-iron-200 tw-border-0 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out`;
  const t5 = `copy-activity-${value}`;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CopyIcon />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== handleCopy || $[8] !== t4 || $[9] !== t5) {
    t7 = <button onClick={handleCopy} className={t4} data-tooltip-id={t5}>{t6}</button>;
    $[7] = handleCopy;
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isTouchScreen || $[12] !== value) {
    t8 = !isTouchScreen && <Tooltip id={`copy-activity-${value}`} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>Copy</Tooltip>;
    $[11] = isTouchScreen;
    $[12] = value;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9 || $[18] !== titleToShow) {
    t10 = <span className="tw-h-6 tw-whitespace-nowrap tw-group tw-inline-flex tw-text-base tw-font-medium tw-text-iron-200">{titleToShow}{t9}</span>;
    $[17] = t9;
    $[18] = titleToShow;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}